// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"817a1985","732":"cfaebfa0"}[chunkId] + ".chunk.js";
};